/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'basic/asterisk-1288243': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18.562 14.634L14 12l4.562-2.634a1 1 0 00-1-1.732L13 10.268V5a1 1 0 00-2 0v5.268L6.438 7.634a1 1 0 00-1 1.732L10 12l-4.562 2.634a1 1 0 001 1.732L11 13.732V19a1 1 0 002 0v-5.268l4.562 2.634a1 1 0 001-1.732z"/>'
  }
})
